// Утилиты для работы с аутentifikací через PHP API (HttpOnly cookie)
import { getCurrentUser } from './phpAuth'

/**
 * Проверяет, разрешен ли домен email для доступа
 */
export function isEmailDomainAllowed(email: string | null | undefined): boolean {
  return !!email
}

export async function getAuthUserData() {
  const user = await getCurrentUser()
  if (!user) {
    return null
  }

  return {
    id: user.id,
    email: user.email || '',
    name: user.name || user.email?.split('@')[0] || 'User',
  }
}

export async function loadUserFromDatabase(userId: string) {
  try {
    const API_BASE_URL = window.location.origin + '/api'

    const response = await fetch(`${API_BASE_URL}/users/${userId}`, {
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    })

    if (!response.ok) {
      return { data: null, error: { message: `HTTP ${response.status}` } }
    }

    const data = await response.json()
    return { data, error: null }
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : String(error)
    return { data: null, error: { message } }
  }
}

export async function createUserInDatabase(userId: string, email: string, name: string) {
  try {
    const API_BASE_URL = window.location.origin + '/api'

    const emailLower = email.toLowerCase().trim()
    const isEmployeeDomain = emailLower.endsWith('@iss-cheb.cz')
    const isStudentDomain = emailLower.endsWith('@student.iss-cheb.cz')
    const userType = !isEmployeeDomain && !isStudentDomain ? 'guest' : null

    const requestBody: Record<string, unknown> = {
      id: userId,
      email,
      name,
    }

    if (userType !== null) {
      requestBody.user_type = userType
    }

    const response = await fetch(`${API_BASE_URL}/users`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(requestBody),
    })

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: response.statusText }))
      return { success: false, error }
    }

    return { success: true, error: null }
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : String(error)
    return { success: false, error: { message } }
  }
}

import { UserRole, AdminType } from '../types'

export async function ensureUserExists(): Promise<{
  id: string
  email: string
  name: string
  role: UserRole | null
  admin_type: AdminType | null
  user_type?: 'guest' | 'student' | 'employee'
} | null> {
  try {
    const authData = await getAuthUserData()
    if (!authData) {
      console.error('No auth user data available')
      return null
    }

    const { data: userData, error: loadError } = await loadUserFromDatabase(authData.id)

    if (userData) {
      return userData
    }

    if (loadError) {
      const { success, error: createError } = await createUserInDatabase(
        authData.id,
        authData.email,
        authData.name,
      )

      if (!success) {
        if (
          createError?.message?.includes('duplicate') ||
          createError?.message?.includes('already exists')
        ) {
          const { data: existingUser } = await loadUserFromDatabase(authData.id)
          if (existingUser) return existingUser
        }
        console.error('Failed to create user:', createError)
        return null
      }

      const { data: newUserData } = await loadUserFromDatabase(authData.id)
      if (newUserData) return newUserData
    }

    return null
  } catch (error) {
    console.error('Error in ensureUserExists:', error)
    return null
  }
}
